// Graphics
import ExcellentIcon from './assets/excellent.png';
import GoodsIcon from './assets/good.png';
import NeutralIcon from './assets/neutral.png';
import BadIcon from './assets/bad.png';
import VeryBadIcon from './assets/verybad.png';
import SupportAvatar from './assets/support_avatar.png';

export interface ICloseDialogModalProps {
    isOpen: boolean;
    onClose: () => void;
    afterClose: () => void;
}

export const OPEN_STATUS = 'open';
export const CLOSE_STATUS = 'closed';
export const ALL_STATUS = 'all';
export const MIN_SEARCH_MESSAGE_LENGTH = 2;
export const MAX_DIALOGS_LIST_MESSAGE_LENGTH = 120;
export const UPLOAD_IMAGES_LIMIT = 3;
export const UPLOAD_FILE_EXT_SUPPORT = '.jpg, .jpeg, .png, .pdf';
export const NOT_IMAGE_FILE_EXT = ['pdf'];
export const UPLOAD_IMAGE_SIZE_LIMIT = 2097152;
export const MODAL_UPLOAD_FILES_CONTAINER = 'uploadedFilesModal';
export const DIALOG_UPLOAD_FILES_CONTAINER = 'uploadedFilesDialog';
export const DIALOG_STATUS_OPEN = 'open';
export const DIALOG_STATUS_CLOSE = 'closed';

export const DIALOG_RATE_ICON_BY_STATUS = {
    '1': VeryBadIcon,
    '2': BadIcon,
    '3': NeutralIcon,
    '4': GoodsIcon,
    '5': ExcellentIcon,
};

export const SUPPORT_AVATAR = SupportAvatar;
